var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.56,
    viewBox: "0 0 18 17.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21009",
    "data-name": "Path 21009",
    d: "M20056.574-9182.44a2.587,2.587,0,0,1-.508-.049h0a2.581,2.581,0,0,1-2.068-2.522v-12.7a2.445,2.445,0,0,1,2.576-2.285h12.854a2.443,2.443,0,0,1,2.57,2.285v12.7a2.575,2.575,0,0,1-2.57,2.571Zm-1.416-2.571a1.42,1.42,0,0,0,1.416,1.417h12.854a1.417,1.417,0,0,0,1.412-1.417v-9.95h-4.211a.084.084,0,0,0-.064.03l-.818.97a1.24,1.24,0,0,1-.949.442h-3.6a1.242,1.242,0,0,1-.947-.442l-.82-.97a.076.076,0,0,0-.064-.03h-4.209Zm0-12.7v1.6h4.209a1.232,1.232,0,0,1,.949.438l.822.969a.072.072,0,0,0,.061.03h3.6a.076.076,0,0,0,.064-.03l.82-.969a1.228,1.228,0,0,1,.947-.437h4.211v-1.6a1.29,1.29,0,0,0-1.412-1.125h-12.854A1.292,1.292,0,0,0,20055.158-9197.715Zm.908,15.226Zm4.275-6.265a.582.582,0,0,1-.578-.583.582.582,0,0,1,.578-.577h5.314a.582.582,0,0,1,.582.577.583.583,0,0,1-.582.583Z",
    transform: "translate(-20053.998 9200)",
    fill: "#242424",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive-icon.b99f2d6e68784070567b41d5e3dd26aa.svg";
export { ForwardRef as ReactComponent };